module.exports = __webpack_public_path__ + "static/media/CZ.cb0f1a69.png";